import { StageMenu } from './StageMenu';

type BorderedAddButtonProps = {
   index: number;
};

export function BorderedAddButton({ index }: BorderedAddButtonProps) {
   return <StageMenu index={index} border="1px solid" borderColor="gray.300" borderRadius="md" />;
}
